class CustomCartHandler extends HTMLElement {
  constructor() {
    super();

    // listen for clicks inside this component
    this.addEventListener("click", (e) => {
      // form-based ATC buttons
      const formBtn = e.target.closest("form[action='/cart/add'] button[type='submit']");
      if (formBtn) {
        formBtn.classList.add("addtocart_active");
        e.preventDefault();
        e.stopImmediatePropagation();
        // if (this.closest(".modal--quickshop-full")) {
        //   const checkbox = this.closest(".modal--quickshop-full").querySelector(".checkbox_terms input");

        //   if (checkbox && checkbox.checked) {
        //     // Checkbox is checked → proceed
        //     this.handleFormAdd(formBtn);
        //   } else {
        //     // Checkbox not checked → show alert
        //     formBtn.classList.remove("addtocart_active");
        //     alert("Please agree to the terms and conditions before making a purchase!");
        //   }
        // }else{
        this.handleFormAdd(formBtn);
        

      }

      // quick-buy buttons with data-variant-id (skip if data-quickshop-slim)
      const quickBtn = e.target.closest("button[data-variant-id]");
      if (quickBtn && !quickBtn.hasAttribute("data-quickshop-slim")) {
        quickBtn.classList.add("addtocart_active");
        e.preventDefault();
        e.stopImmediatePropagation();
        this.handleQuickAdd(quickBtn);
      }
    });
  }

  async handleFormAdd(btn) {
    const form = btn.closest("form");
    if (!form) return;

    // remove old error if any
    const oldError = form.querySelector(".variant-error");
    if (oldError) oldError.remove();

    // check for variant ID field 
    const variantInput = form.querySelector("[name='id']");
    if (!variantInput || !variantInput.value) {
      const errorEl = document.createElement("div");
      errorEl.className = "variant-error";
      errorEl.style.color = "red";
      errorEl.style.marginTop = "8px";
      errorEl.textContent = "⚠️ Please select a variant before adding to cart.";
      form.appendChild(errorEl);
      return;
    }

    const formData = new FormData(form);
    await this.addToCart(formData, btn);
  }

  async handleQuickAdd(btn) {
    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    await this.addToCart(formData, btn);
  }

  async addToCart(formData, btn) {
    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        body: formData
      });
      const addedItem = await addRes.json();
      console.log("✅ Added to cart:", addedItem);

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        const res = await fetch("/cart?view=drawer");
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("cart-drawer");
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }

                  cartDrawer.querySelector("#CartDrawer-CartItems").classList.remove("fade");
          cartDrawer.querySelector("#CartDrawer-CartItems").classList.add("fade-in");

          setTimeout(() => cartDrawer.querySelector("#CartDrawer-CartItems").classList.remove("fade-in"), 500);

        cartDrawer.classList.remove("is-empty");
        // if(btn.closest(".modal--quickshop-full")){
        //   window.location.href = "/checkout";
        // }else{
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();

          // 🔹 remove active class after drawer opens
          if (btn) {
            btn.classList.remove("addtocart_active");
            if(btn.closest(".modal.modal--quickshop-slim")){
              btn.closest(".modal.modal--quickshop-slim").querySelector(".modal-close").click();
            }
            if(btn.closest(".modal.modal--quickshop-full")){
              btn.closest(".modal.modal--quickshop-full").querySelector(".modal-close").click();
            }
          }
        }
      

        // update cart count
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();
        const countEl = document.querySelector("#cart-icon-bubble [data-header-cart-count]");
        if (countEl) {
          countEl.setAttribute("data-header-cart-count", cartData.item_count);
        }
      }

    } catch (err) {
      console.error("⚠️ Add error:", err);
    }
  }
}

// register custom element
customElements.define("custom-cart-handler", CustomCartHandler);




// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('click', async (event) => {
//       event.preventDefault();
      

//       const index = parseInt(this.dataset.index);
//       if (!index) return;

//       const lineItemRow = document.querySelector(`#CartDrawer-Item-${index}`);
//       if (!lineItemRow) return;

//       try {
//         const response = await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           body: JSON.stringify({
//             line: index,
//             quantity: 0
//           })
//         });

//         const updatedCart = await response.json();

//         // Remove row
//         lineItemRow.remove();

//         // Update cart count
//         document.querySelectorAll('[data-header-cart-count]').forEach(el => {
//           el.setAttribute("data-header-cart-count", updatedCart.item_count);
//         });

//         // 🔥 Refresh drawer (so total price updates too)
//         const cartDrawer = document.querySelector("cart-drawer");
//         if (cartDrawer) {
//           const res = await fetch("/cart?view=drawer");
//           const html = await res.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");
//           const newDrawer = doc.querySelector("cart-drawer");
//           if (newDrawer) {
//             cartDrawer.innerHTML = newDrawer.innerHTML;
//           }
//         }
//         const cartRes = await fetch("/cart.js");
//         const cartData = await cartRes.json();

//         const countEl = document.querySelector("#cart-icon-bubble [data-header-cart-count]");
//         if (countEl) {
//           countEl.setAttribute("data-header-cart-count", cartData.item_count);
//         }

//         if (cartDrawer) {
//           if (cartData.item_count === 0) {
//             cartDrawer.classList.add("is-empty");
//           }
//         }

//       } catch (error) {
//         console.error('Error removing item from cart:', error);
//       }
//     });
//   }
// }

// customElements.define('cart-remove-button', CartRemoveButton);

// document.addEventListener("DOMContentLoaded", function () {
//   // Select all quick-buy buttons with data-variant-id
//   const quickBuyButtons = document.querySelectorAll("button[data-variant-id]");

//   quickBuyButtons.forEach((btn) => {
//     btn.addEventListener("click", async function (e) {
//       if (btn.hasAttribute("data-quickshop-slim")) {
//         return;
//       }
//       e.preventDefault();
//       e.stopImmediatePropagation();

//       // 🚫 Skip if button has data-quickshop-slim attribute
      

//       const variantId = btn.getAttribute("data-variant-id");
//       if (!variantId) return;

//       // Create payload for AJAX add-to-cart
//       const formData = new FormData();
//       formData.append("id", variantId);
//       formData.append("quantity", 1);

//       try {
//         // Add to cart
//         const addRes = await fetch("/cart/add.js", {
//           method: "POST",
//           body: formData
//         });
//         const addedItem = await addRes.json();
//         console.log("✅ Added to cart:", addedItem);

//         // Update drawer
//         const cartDrawer = document.querySelector("cart-drawer");
//         if (cartDrawer) {
//           const res = await fetch("/cart?view=drawer");
//           const html = await res.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");
//           const newDrawer = doc.querySelector("cart-drawer");
//           if (newDrawer) {
//             cartDrawer.innerHTML = newDrawer.innerHTML;
//           }

//           // if cart has items
//           cartDrawer.classList.remove("is-empty");

//           if (typeof cartDrawer.open === "function") {
//             cartDrawer.open();
//           }
//         }

//         // Update header cart count
//         const cartRes = await fetch("/cart.js");
//         const cartData = await cartRes.json();
//         const countEl = document.querySelector("#cart-icon-bubble [data-header-cart-count]");
//         if (countEl) {
//           countEl.setAttribute("data-header-cart-count", cartData.item_count);
//         }

//       } catch (err) {
//         console.error("⚠️ Add error:", err);
//       }
//     });
//   });
// });

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", async (event) => {
      event.preventDefault();

      const index = parseInt(this.dataset.index);
      if (!index) return;

      const lineItemRow = document.querySelector(`#CartDrawer-Item-${index}`);
      if (!lineItemRow) return;

      // 🔥 Add fade-out class to item being removed
      lineItemRow.classList.add("is-being-removed");

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            line: index,
            quantity: 0,
          }),
        });

        const updatedCart = await response.json();

        // Wait for fade animation to complete before removing element
        setTimeout(() => {
          lineItemRow.remove();
        }, 100);

        // Update cart count badge
        document.querySelectorAll("[data-header-cart-count]").forEach((el) => {
          el.setAttribute("data-header-cart-count", updatedCart.item_count);
        });

        // 🔥 Fade the drawer content before refreshing
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          const res = await fetch("/cart?view=drawer");
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newDrawer = doc.querySelector("cart-drawer");

          if (newDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }
        }

        // Update cart count bubble again (for safety)
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();
        const countEl = document.querySelector("#cart-icon-bubble [data-header-cart-count]");
        if (countEl) {
          countEl.setAttribute("data-header-cart-count", cartData.item_count);
        }

        // If empty, mark drawer empty
        if (cartDrawer && cartData.item_count === 0) {
          cartDrawer.classList.add("is-empty");
        }
      } catch (error) {
        console.error("Error removing item from cart:", error);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);




document.addEventListener("DOMContentLoaded", function () {
  // Select all quick-buy buttons with data-variant-id
  const quickBuyButtons = document.querySelectorAll("button[data-variant-id]");

  quickBuyButtons.forEach((btn) => {
    btn.addEventListener("click", async function (e) {
      if (btn.hasAttribute("data-quickshop-slim")) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();

      // 👉 Add active class on click
      btn.classList.add("addtocart_active");

      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      // Create payload for AJAX add-to-cart
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      try {
        // Add to Cart
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData
        });
        const addedItem = await addRes.json();
        console.log("✅ Added to cart:", addedItem);

        // Update drawer
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          const res = await fetch("/cart?view=drawer");
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newDrawer = doc.querySelector("cart-drawer");
          if (newDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }

                    cartDrawer.querySelector("#CartDrawer-CartItems").classList.remove("fade");
          cartDrawer.querySelector("#CartDrawer-CartItems").classList.add("fade-in");

          setTimeout(() => cartDrawer.querySelector("#CartDrawer-CartItems").classList.remove("fade-in"), 500);

          // if cart has items
          cartDrawer.classList.remove("is-empty");

          if (typeof cartDrawer.open === "function") {
            cartDrawer.open();

            // 👉 remove active class after drawer opens
            btn.classList.remove("addtocart_active");
          }
        }

        // Update header cart count
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();
        const countEl = document.querySelector("#cart-icon-bubble [data-header-cart-count]");
        if (countEl) {
          countEl.setAttribute("data-header-cart-count", cartData.item_count);
        }

      } catch (err) {
        console.error("⚠️ Add error:", err);
        // in case of error also remove active class
        btn.classList.remove("addtocart_active");
      }
    });
  });
});
